import React, { useRef } from "react";
import { Button } from "@material-ui/core";
import { CallEnd } from "@material-ui/icons";
import { endCallEvent } from "../utils/callEvent";

const EndCallButton = ({ onEndCall }) => {
  const clickTimerRef = useRef(null);
  const clickSeenRef = useRef(false);
  const lastSentRef = useRef(0);

  const sendToFlutter = () => {
    setTimeout(() => {
        const now = Date.now();
        // debounce to avoid double fire from touch + click
        if (now - lastSentRef.current < 800) return;
        lastSentRef.current = now;
    
        try {
          if (window.AppBridge && window.AppBridge.postMessage) {
            window.AppBridge.postMessage(
              JSON.stringify({ type: "end_call", ts: now, page: window.location.href })
            );
          }
        } catch (_) {}
    }, 2000);
  };

  const handleEndCall = async () => {
    await endCallEvent();
    onEndCall?.();
  };

  const scheduleClickFallback = () => {
    if (clickTimerRef.current) window.clearTimeout(clickTimerRef.current);
    clickSeenRef.current = false;

    clickTimerRef.current = window.setTimeout(() => {
      // If click never happened, force a click as a last resort
      if (!clickSeenRef.current) {
        const el = document.getElementById("iconnect-end-call-button");
        el?.click();
      }
    }, 3000);
  };

  const handleClick = async (e) => {
    clickSeenRef.current = true;
    if (clickTimerRef.current) window.clearTimeout(clickTimerRef.current);

    // Always notify Flutter too (don’t rely on injected JS catching click)
    sendToFlutter();

    await handleEndCall();
  };

  const handleTouchEnd = async (e) => {
    // Prevent the “ghost click” in some cases; but keep this if you see double fires.
    e.preventDefault();

    // Immediately notify Flutter on touch (this is the real fix)
    sendToFlutter();

    // Start fallback timer in case click never comes
    scheduleClickFallback();

    await handleEndCall();
  };

  return (
    <Button
      variant="contained"
      onClick={handleClick}
      onTouchEnd={handleTouchEnd}
      id="iconnect-end-call-button"
      sx={{
            backgroundColor: {
                xs: "error.main",
                md: "background.paper",
            },
            color: {
                xs: "white",
                md: "error.main",
            },
            ml: 1,
            position: { xs: 'fixed', md: 'static' },
            bottom: { xs: "68px", md: 'auto' },
            right: { xs: '16px', md: 'auto' },
            zIndex: { xs: 1300, md: 'auto' },
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, md: 0 },
            '&:hover': {
              backgroundColor: {
                xs: "white",
                md: "background.paper",
              },
              color: {
                xs: "error.main",
                md: "error.main",
              },
            }
        }}
    >
      <CallEnd />
      End Call
    </Button>
  );
};

export default EndCallButton;
